import { TagInput, TagInputProps } from 'emblor';
import { FieldPath, FieldValues, useController } from 'react-hook-form';
import { cn } from '../../utils/cn';

export const InputTag = <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>(
  props: TagInputProps,
) => {
  const field = useController<TFieldValues, TName>({
    name: props.inputName,
  });
  const errors = field.fieldState.error as unknown as { text: { message: string; type: string } }[];

  return (
    <>
      <TagInput
        {...props}
        styleClasses={{
          inlineTagsContainer: cn(
            'bg-seapoint-gray-background-modal rounded-lg border-[0.5px] border-seapoint-gray-border p-3 min-h-[57px]',
          ),
          tagList: {
            container: 'bg-red-500',
            sortableList: 'bg-blue-500',
          },
          tag: {
            body: 'bg-white rounded-[10px] py-1.5 text-black text-xs font-medium leading-6 tracking-tight px-2',
            closeButton: 'text-seapoint-gray font-medium px-0 ml-2.5 [&>svg]:w-4 [&>svg]:h-4',
          },
          input: 'text-black text-xs font-medium leading-6 tracking-tight pl-0 shadow-none',
        }}
      />

      {errors &&
        errors.map((e) => {
          return (
            <p key={e.text.message} className="text-sm font-medium text-seapoint-red">
              {e.text.message}
            </p>
          );
        })}
    </>
  );
};
